export const VIDEO_MP4_MIME = 'video/mp4';
